import type { JQueryStatic } from "@modules/jquery-types.ts"

export class CharacterCount {
    private counterElementClass = "character-counter"

    constructor() {
        const lengthSelector = '.count-length[maxlength][maxlength!=""]'

        $(document).on(
            "click keydown keyup keypress change paste input",
            lengthSelector,
            this.countRemainingCharacterLength.bind(this),
        )

        // Zum initialisieren Event einmalig direkt aufrufen
        $(lengthSelector).trigger("input")
    }

    private countRemainingCharacterLength(inputEvent: InputEvent): void {
        const textInputElement = $(inputEvent.currentTarget)
        const counterParentElement = textInputElement.parent()
        let counterElement = counterParentElement.find(`.${this.counterElementClass}`)
        const currentLength = textInputElement.val().length
        const maxLength = Number.parseInt(textInputElement.attr("maxlength"), 10)

        if (!counterElement.length) {
            counterElement = this.addCounterElement(counterParentElement)
        }

        counterElement.text(`${currentLength} ⁄ ${maxLength}`)
    }

    private addCounterElement(parentElement: JQueryStatic): JQueryStatic {
        const counterElement = $("<span>")

        counterElement.addClass(this.counterElementClass).appendTo(parentElement)

        return counterElement
    }
}
